import React from 'react';
import TabbedSection from '../components/TabbedSection';

import Roles from './Roles/Roles';
import Teams from './Teams';
import Users from './Users/Users';
import AllRequests from './Requests/AllRequests';
import AllContacts from './Contact/AllContacts';
import AllNewsletters from './Newsletter/AllNewsletters';
import AccountDeletions from './AccountDeletions/AccountDeletions';

/**
 * Roles, Teams, Users, Requests, Contacts and Newsletters on one page.
 *
 * They are all the same subject — who a person is and what they sent us — and
 * were six sidebar entries and six page loads to answer one question about
 * one of them.
 */
const TABS = [
  { key: 'roles', label: 'Roles', Component: Roles },
  { key: 'teams', label: 'Teams', Component: Teams },
  { key: 'users', label: 'Users', Component: Users },
  { key: 'requests', label: 'Requests', Component: AllRequests },
  { key: 'contacts', label: 'Contacts', Component: AllContacts },
  { key: 'newsletters', label: 'Newsletters', Component: AllNewsletters },
  // Erasure requests have a statutory clock on them; they were invisible
  // until this tab existed.
  { key: 'account-deletions', label: 'Deletion requests', Component: AccountDeletions },
];

const Management = () => <TabbedSection title="Management" basePath="/management" tabs={TABS} />;

export default Management;
